<template>
    <div>
        {{$t("content.paragraph1")}}
        <br><br>
        {{$t("content.paragraph2")}}
        <br><br>
        {{$t("content.paragraph3")}}
        <br><br>
        {{$t("content.paragraph4")}}
        <br><br>
        {{$t("content.paragraph5")}}
    </div>
</template>

<script>
export default {
  name: "group-content"
};
</script>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupContent.vue